const solutionList = () => import('@/pages/solution/index.vue');
const solutionForm = () => import('@/pages/solution/form.vue');

export default [{
    path: '/solution/list',
    component: solutionList,
    meta: [{
        name: '解决方案管理'
    },
    {
        name: '解决方案列表',
        activeRoute: '/solution/list'
    }]
}, {
    path: '/solution/form',
    component: solutionForm,
    meta: [{
        name: '解决方案管理'
    },
    {
        name: '解决方案列表',
        url: '/solution/list',
    },
    {
        name: '解决方案详情',
        activeRoute: '/solution/list'
    }]
}];